/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteSession.defs.js'
export { main as default } from './deleteSession.defs.js'
